import { render, staticRenderFns } from "./AdditionalDetail.vue?vue&type=template&id=58efd466&scoped=true&"
import script from "./AdditionalDetail.vue?vue&type=script&lang=js&"
export * from "./AdditionalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efd466",
  null
  
)

export default component.exports